import { useState } from "react";
import {
  useCategories,
  useUpdateTransaction,
  Transaction,
} from "../../services/useTransactions";
import SuggestionAutocomplete from "./SuggestionAutocomplete";
import type { Suggestion } from "../../services/useSuggestions";

type Props = { tx: Transaction };

export default function TransactionRow({ tx }: Props) {
  const { data: cats = [] } = useCategories();
  const update = useUpdateTransaction();

  const [catSlug, setCatSlug] = useState(tx.category ?? "");
  const [suggestion, setSuggestion] = useState<Suggestion | null>(
    tx.content_type && tx.object_id
      ? {
          id: tx.object_id,
          type: tx.content_type,
          label: tx.label,
        }
      : null,
  );
  const [note, setNote] = useState(tx.note ?? "");

  const matched = !!tx.category || (!!tx.content_type && !!tx.object_id);

  function save() {
    const payload: any = {};
    if (suggestion) {
      payload.content_type = suggestion.type;
      payload.object_id = suggestion.id;
    } else {
      payload.content_type = null;
      payload.object_id = null;
    }

    payload.category = catSlug;
    payload.note = note;

    update.mutate({ id: tx.id, data: payload });
  }

  return (
    <tr className={matched ? "bg-green-50" : ""}>
      <td className="border border-black p-1">{tx.bank_date}</td>
      <td className="border border-black p-1">{tx.description}</td>
      <td className="border border-black p-1 text-right">{tx.amount}</td>
      <td className="border border-black p-1">
        <div className="flex gap-1 mb-1">
          <select
            value={catSlug}
            onChange={(e) => setCatSlug(e.target.value)}
            className="border border-black p-1"
          >
            <option value="">- Categoria -</option>
            {cats.map((c) => (
              <option key={c.id} value={c.slug}>
                {c.name}
              </option>
            ))}
          </select>
          <div className="flex-grow w-full mt-1">
            <SuggestionAutocomplete
              onSelect={setSuggestion}
              suggestion={suggestion}
            />
          </div>
          <textarea
            className="border border-black w-full p-1 mt-1 text-sm"
            rows={1}
            placeholder="Nota"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
          <button
            className="mt-1 px-2 bg-blue-600 text-white rounded"
            onClick={save}
          >
            Salvar
          </button>
        </div>
      </td>
    </tr>
  );
}
